"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-8b67639c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "timeContent" };
const _hoisted_2 = { class: "time" };
const _hoisted_3 = { class: "date" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const timeData = (0, vue_3.reactive)({ value: { date: '', time: '', week: '' } });
        const changeZH = (day) => {
            switch (day) {
                case 1:
                    return "一";
                case 2:
                    return "二";
                case 3:
                    return "三";
                case 4:
                    return "四";
                case 5:
                    return "五";
                case 6:
                    return "六";
                case 7:
                    return "日";
                default:
                    return "一";
            }
        };
        const zeroFill = (value) => {
            let newValue = value;
            if (newValue < 10) {
                newValue = "0" + newValue;
            }
            return newValue;
        };
        const currentTime = () => {
            let now = new Date();
            let year = now.getFullYear();
            //年
            let month = zeroFill(now.getMonth() + 1);
            //月
            let day = zeroFill(now.getDate());
            //日
            let hh = zeroFill(now.getHours());
            //时
            let mm = zeroFill(now.getMinutes());
            //分
            let ss = zeroFill(now.getSeconds());
            //秒
            let week = now.getDay();
            //星期
            return {
                date: `${year}.${month}.${day}`,
                time: `${hh}:${mm}:${ss}`,
                week: `周${changeZH(week)}`,
            };
        };
        const refrechTime = () => {
            requestAnimationFrame(() => {
                timeData.value = currentTime();
                refrechTime();
            });
        };
        (0, vue_3.onMounted)(() => {
            refrechTime();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(timeData.value.time), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(timeData.value.week), 1),
                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(timeData.value.date), 1)
                ])
            ]));
        };
    }
});
